import React, { FC, memo } from 'react'
import { Collapse } from 'antd'
import { useIntl } from 'react-intl'

const { Panel } = Collapse

const RegistryProblems: FC = () => {
    const intl = useIntl()

    return (
        <div>
            <Collapse accordion bordered={false} expandIconPosition="right" className="landing-page-faq-collapse">
                <Panel
                    header="没有报名可以观看直播吗？"
                    key="1"
                    className="landing-page-faq-collapse-header"
                >
                    <p>抱歉，谷歌出海大讲堂为定向邀请制。如您感兴趣，请联系您的谷歌客户经理了解更多。</p>
                </Panel>
                <Panel
                    header="如何确定已经报名成功？"
                    key="2"
                    className="landing-page-faq-collapse-header"
                >
                    <p>您将在直播前 1-7 个工作日收到报名确认函，内含观看链接。</p>
                </Panel>
                <Panel
                    header="如何邀请同事/同业伙伴观看直播？"
                    key="3"
                    className="landing-page-faq-collapse-header"
                >
                    <p>方法一：本活动采邀请制，您可以分享直播邀请函给您的同事/同业伙伴，在报名截止日前完成报名。</p>
                    <p>方法二：新用户可前往「谷歌出海大讲堂」学习平台注册报名。申请通过后，您将第一时间收到直播报名邮件。</p>
                    <p>*登入本网站需要签署 NDA，若您尚未签署可联系您的谷歌经理</p>
                    <img 
                        src='https://oss.uppmkt.com/2024/website/adsacademy/sign_qr.svg' 
                        alt="qrcode"
                        style={{ maxWidth: '220px' }}/>                    
                </Panel>
                <Panel
                    header={intl.formatMessage({ id: 'landingPage.faq_category1_q4' })}
                    key="4"
                    className="landing-page-faq-collapse-header"
                >
                    <p>{intl.formatMessage({ id: 'landingPage.faq_category1_a4' })}</p>
                </Panel>
            </Collapse>
        </div>
    )
}

export default memo(RegistryProblems)
